var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import dayjs from 'dayjs';
import { API_URLS } from '../../constants/apiConstants';
import { GATEWAY_URL } from '../../utils/common/apiConfig';
import httpGet from '../../utils/http/httpGet';
/**
 * TTV, BUFFER 정보 요청
 * @param requestParameter: 요청 파라미터
 * @param requestConfig : axios 요청 설정
 * @returns
 */
var fetchTtvBuffer = function (requestParameter, requestConfig) {
    if (requestConfig === void 0) { requestConfig = {}; }
    var poc = requestParameter.poc;
    var params = { v: dayjs(Date.now(), 'Asia/Seoul').format('YYYYMMDDHHmm') };
    var filledRequestConfig = __assign(__assign({}, requestConfig), { params: params });
    return httpGet("".concat(GATEWAY_URL).concat(API_URLS.TTV_BUFFER_MODE.replace('{poc}', poc)), filledRequestConfig)
        .then(function (response) {
        return response.data;
    })
        .catch(function (e) {
        throw e;
    });
};
export default fetchTtvBuffer;
